import React, { ReactNode } from 'react'
import cn from 'classnames'
import { StyledHint } from './styledComponents'

type HintProps = {
  id: string
  hint?: ReactNode
  renderHintLeftIcon?: () => ReactNode
  errorText?: string
  accessibilityProps?: any
  hintClassName?: string
  styledHintClassName?: string
}

export function Hint({
  id,
  hint,
  errorText,
  hintClassName,
  renderHintLeftIcon,
  styledHintClassName
}: HintProps) {
  const renderHint = (): ReactNode => {
    return (
      <>
        {renderHintLeftIcon && renderHintLeftIcon()}
        {hint}
      </>
    )
  }

  if ((errorText && errorText !== '') || (hint && hint !== '')) {
    return (
      <StyledHint
        id={id}
        errorText={!!errorText}
        className={styledHintClassName}
      >
        {errorText || renderHint()}
      </StyledHint>
    )
  } else {
    return <div className={cn('h-20px', hintClassName)}></div>
  }
}
